import { Grid, Typography } from "@mui/material";
import ListAddedIcon from "@mui/icons-material/AddBox";
import ListRemoveIcon from "@mui/icons-material/IndeterminateCheckBox";
import ListAllIcon from "@mui/icons-material/ListAlt";
import Tooltip from "@mui/material/Tooltip";

interface ICrewDisplayModeProps {
  displayMode: string;
  setDisplayMode: (mode: "removed" | "all" | "added") => void;
  addedCount: number;
  removedCount: number;
}

/**
 * Set Crew table view to show only removed crew, added crew or all.
 * @param props -
 */
export const CrewDisplayMode = (props: ICrewDisplayModeProps): JSX.Element => {
  const { displayMode, setDisplayMode, addedCount, removedCount } = props;
  return (
    <Grid container className="crew_change_buttons">
      <Typography variant="caption" className="label">
        Status
      </Typography>
      <Tooltip enterDelay={500} placement="top" title={`Show only crew being removed from package (${removedCount})`}>
        <ListRemoveIcon
          className={`icon removed ${displayMode === "removed" ? "active" : ""}`}
          onClick={() => setDisplayMode("removed")}
        />
      </Tooltip>
      <Tooltip enterDelay={500} placement="top" title={"Show all crew (in current package and selected groups)"}>
        <ListAllIcon
          className={`icon nochange ${displayMode === "all" ? "active" : ""}`}
          onClick={() => setDisplayMode("all")}
        />
      </Tooltip>
      <Tooltip enterDelay={500} placement="top" title={`Show only crew being added to package  (${addedCount})`}>
        <ListAddedIcon
          className={`icon added ${displayMode === "added" ? "active" : ""}`}
          onClick={() => setDisplayMode("added")}
        />
      </Tooltip>
    </Grid>
  );
};
